import FirstTimePakCard from './component'
export default FirstTimePakCard
